import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import ApiSites from "@/services/sites.js";
import Gtag from "@/plugins/vue-gtag";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    filters: [],
    items: [],
    searchTerm: "",
    selectedCategory: null,
    config: {}
  },
  actions: {
    async setConfig({ commit }) {
      try {
        const data = await fetch("/config.json");
        const localConfig = await data.json();
        Vue.prototype.$http.defaults.baseURL = localConfig.apiUrl;
        Vue.prototype.$http.defaults.headers.common["x-uid"] = localConfig.uid;
        Vue.prototype.$http.defaults.baseURL = localConfig.apiUrl;
        const websiteId = localConfig.websiteId;
        const config = (await ApiSites.config({ websiteId })).data;
        commit("SET_CONFIG", config.website);
        if (config.website.isPro && config.website.gaId) {
          Gtag.setGtag(config.website.gaId);
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getItems({ commit, state }) {
      try {
        const params = { filterBy: state.config?.listView?.filterBy?.name };
        const res = await axios.get(
          `api/sheets/${state.config.sheet.id}/items`,
          {
            params
          }
        );
        commit("setItems", res.data.items);
        commit("setFilters", res.data.filters);
      } catch (error) {
        console.log(error);
      }
    }
  },
  mutations: {
    setItems(state, value) {
      state.items = value;
    },
    setFilters(state, value) {
      state.filters = value;
    },
    setSearchTerm(state, value) {
      state.searchTerm = value;
    },
    setSelectedCategory(state, value) {
      state.selectedCategory = value;
    },
    ["SET_CONFIG"](state, config) {
      state.config = config;
    }
  }
});
